module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcthigh1-a5c8d66a604e77303a437a7ee0ab2558.jpg";